// extracted by mini-css-extract-plugin
export default {"card":"HorizentalCard_card__KSWLH","cardSelected":"HorizentalCard_cardSelected__QiKqp","text":"HorizentalCard_text__3R9mO","icon":"HorizentalCard_icon__hAQiu"};